var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReiseterminViewBesonderheiten',{attrs:{"value":_vm.besonderheiten,"isSaved":_vm.isSaved},on:{"onKeyUp":_vm.onKeyUp}})
}
var staticRenderFns = []

export { render, staticRenderFns }